import { gql, useQuery } from "@apollo/client";

export const USER_MODEL_3D_FIELDS = gql`
  fragment UserModel3DFields on UserModel3D {
    id
    name
    displayTitle
    displayDescription
    uploaderId
    uploaderName
    originalFilename
    status
    source
    stage
    progress
    errorMessage
    shareWithCommunity
    isCommunityListed
    communityListingState
    firstSharedAt
    ownerArchivedAt
    moderationState
    optimizedUrl
    thumbnailUrl
    sourceImageUrl
    footprintSvg
    architectureSymbolKey
    dimensions {
      width
      depth
      height
    }
    bounds {
      min
      max
      center
      size {
        width
        depth
        height
      }
    }
    price
    currency
    url
    brand
    fileBytes
    triangleCount
    vertexCount
    textureMaxSize
    sha256
    pipelineVersion
    createdAt
    updatedAt
  }
`;

export const UserModels3DDocument = gql`
  ${USER_MODEL_3D_FIELDS}
  query UserModels3D {
    userModels3D {
      ...UserModel3DFields
    }
  }
`;

export const UploadUserModel3DDocument = gql`
  ${USER_MODEL_3D_FIELDS}
  mutation UploadUserModel3D(
    $name: String
    $model: Upload!
    $shareWithCommunity: Boolean
    $price: Float
    $currency: String
    $url: String
    $brand: String
  ) {
    uploadUserModel3D(
      name: $name
      model: $model
      shareWithCommunity: $shareWithCommunity
      price: $price
      currency: $currency
      url: $url
      brand: $brand
    ) {
      ...UserModel3DFields
    }
  }
`;

export const GenerateUserModel3DFromImageDocument = gql`
  ${USER_MODEL_3D_FIELDS}
  mutation GenerateUserModel3DFromImage(
    $name: String!
    $image: Upload!
    $shareWithCommunity: Boolean
    $price: Float
    $currency: String
    $url: String
    $brand: String
  ) {
    generateUserModel3DFromImage(
      name: $name
      image: $image
      shareWithCommunity: $shareWithCommunity
      price: $price
      currency: $currency
      url: $url
      brand: $brand
    ) {
      ...UserModel3DFields
    }
  }
`;

export const RetryUserModel3DGenerationDocument = gql`
  ${USER_MODEL_3D_FIELDS}
  mutation RetryUserModel3DGeneration($id: ID!) {
    retryUserModel3DGeneration(id: $id) {
      ...UserModel3DFields
    }
  }
`;

export const CommunityUserModels3DDocument = gql`
  ${USER_MODEL_3D_FIELDS}
  query CommunityUserModels3D($input: CommunityUserModels3DInput) {
    communityUserModels3D(input: $input) {
      data {
        ...UserModel3DFields
      }
      total
    }
  }
`;

export const useCommunityUserModels3D = (
  variables: {
    input: {
      search?: string;
      sortBy: "NAME" | "RECENT";
      skip: number;
      limit: number;
    };
  },
  skip = false,
) =>
  useQuery(CommunityUserModels3DDocument, {
    variables,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    skip,
  });

export const UploadUserModel3DThumbnailDocument = gql`
  ${USER_MODEL_3D_FIELDS}
  mutation UploadUserModel3DThumbnail($modelId: ID!, $image: Upload!) {
    uploadUserModel3DThumbnail(modelId: $modelId, image: $image) {
      ...UserModel3DFields
    }
  }
`;

export const DeleteUserModel3DDocument = gql`
  mutation DeleteUserModel3D($id: ID!) {
    deleteUserModel3D(id: $id)
  }
`;

export const RenameUserModel3DDocument = gql`
  ${USER_MODEL_3D_FIELDS}
  mutation RenameUserModel3D($id: ID!, $name: String!) {
    renameUserModel3D(id: $id, name: $name) {
      ...UserModel3DFields
    }
  }
`;

export const UpdateUserModel3DDocument = gql`
  ${USER_MODEL_3D_FIELDS}
  mutation UpdateUserModel3D(
    $id: ID!
    $name: String!
    $width: Float
    $depth: Float
    $height: Float
    $architectureSymbolKey: String
    $price: Float
    $currency: String
    $url: String
    $brand: String
  ) {
    updateUserModel3D(
      id: $id
      name: $name
      width: $width
      depth: $depth
      height: $height
      architectureSymbolKey: $architectureSymbolKey
      price: $price
      currency: $currency
      url: $url
      brand: $brand
    ) {
      ...UserModel3DFields
    }
  }
`;
